import { Box, BoxProps, ColorOptions, Icon, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { isEmpty } from '@jfs/utils'
import { useNavigation } from '@react-navigation/core'
import { ReactElement, useCallback, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { ApiConfig } from '../../components/ApiConfig'
import { VerticalStepIndicator } from '../../components/VerticalStepIndicator'
import { useLazyApiData, useStores } from '../../data/store'
import { MessageTypes } from '../../utils'
import ApiOnboarding from '../ApiOnboarding'
import GeneralConfig from '../GeneralConfig'
import { PaymentConfig } from '../PaymentConfig'

const getSteps = (isOnboard: boolean) => {
  return isOnboard
    ? ['Onboarding', 'General Configuration', 'Payment Configuration', 'API Configuration']
    : ['General Configuration', 'Payment Configuration', 'API Configuration']
}

const MerchantOnboarding = ({ visible, setVisible, mid, isOnboarding }: any) => {
  const [currentStep, setCurrentStep] = useState(1)
  const [apiOnboardSucess, setApiOnboardSucess] = useState(false)
  const [accessData, setAccessData] = useState([])
  const [isAllApiFulfilled, setAllApiFulfilled] = useState(false)
  const {
    mercName,
    integrationType,
    sodexo,
    offers,
    getUserDetails,
    accessConfig,
    subscriptions,
    emiFlag,
    tokenizationFlag,
    collectLink,
    updateSelectedApisStatus,
    onboardInsertMerchant,
    insertCards,
    cardsList,
    insertConfigList,
    insertConfig,
    getPaymentConfigData,
    getDefaultConfigsToInsert,
    channelId,
    isAllPciSelected,
    isAllCommonPciNonPciSelected,
    isAllEmisSelected,
    isAllOthersSelected,
    updateSelecteProfileStatus,
    getAllPciList,
    commonPciNonPciList,
    getOthersApisList,
    getEmiList,
    insertMetaConfigList,
    getMetaConfigListRequestData,
    setMessage,
    resetSelectionsDataOnSubmit,
  } = useStores((store) => ({
    mercName: store.onboarding.merchantName,
    integrationType: store.onboarding.integrationType,
    sodexo: store.onboarding.sodexo,
    offers: store.onboarding.offers,
    getUserDetails: store.user.fetchUserDetails,
    accessConfig: store.user.accessConfig,
    subscriptions: store.onboarding.subscriptions,
    emiFlag: store.onboarding.emiFlag,
    tokenizationFlag: store.onboarding.tokenizationFlag,
    collectLink: store.onboarding.collectLink,
    updateSelectedApisStatus: store.updateSelectedApisStatus,
    onboardInsertMerchant: store.onboarding.onboardInsertMerchant,
    insertCards: store.insertCardsSelections,
    cardsList: store.onboarding.cardList,
    insertConfigList: store.insertConfigListSelections,
    insertConfig: store.insertConfigSelection,
    getPaymentConfigData: store.onboarding.getPaymentConfigRequestData,
    getDefaultConfigsToInsert: store.onboarding.getDefaultConfigsToInsert,
    channelId: store.onboarding.channelId,
    isAllPciSelected: store.onboarding.isAllPciSelected,
    isAllCommonPciNonPciSelected: store.onboarding.isAllCommonPciNonPciSelected,
    isAllEmisSelected: store.onboarding.isAllEmisSelected,
    isAllOthersSelected: store.onboarding.isAllOthersSelected,
    updateSelecteProfileStatus: store.updateSelecteProfileStatus,
    getAllPciList: store.getAllPciList,
    commonPciNonPciList: store.getCommonInPciNonPci,
    getOthersApisList: store.getOthersApisList,
    getEmiList: store.getEmiList,
    insertMetaConfigList: store.insertMetaConfigList,
    getMetaConfigListRequestData: store.onboarding.getMetaConfigListRequestData,
    setMessage: store.message.setMessage,
    resetSelectionsDataOnSubmit: store.onboarding.resetSelectionsDataOnSubmit,
  }))

  const navigation = useNavigation()
  const [getUserDetailsApi] = useLazyApiData(getUserDetails)
  const [onboardMerchant, onboardMerchantHandler] = useLazyApiData(onboardInsertMerchant)
  const [insertConfigListApi] = useLazyApiData(insertConfigList)
  const [insertMetaConfigListApi] = useLazyApiData(insertMetaConfigList)
  const [updateIndividualApiStatusApi, updateIndividualApiStatusHandler] = useLazyApiData(updateSelectedApisStatus)
  const [pciUpdateApi, pciUpdateHandler] = useLazyApiData(updateSelecteProfileStatus)
  const [commonPciNonPciApi, commonPciUpdateHandler] = useLazyApiData(updateSelecteProfileStatus)
  const [emiUpdateApi, emiUpdateHandler] = useLazyApiData(updateSelecteProfileStatus)
  const [othersUpdateApi, othersUpdateHandler] = useLazyApiData(updateSelecteProfileStatus)
  const [insertCardsApi, insertCardsHandler] = useLazyApiData(insertCards)
  const [insertConfigApi, insertConfigHandler] = useLazyApiData(insertConfig)

  useEffect(() => {
    if (onboardMerchantHandler.state === 'fulfilled') {
      setApiOnboardSucess(true)
    } else {
      setApiOnboardSucess(false)
    }
  }, [onboardMerchantHandler.state])

  const handleCloseModal = () => {
    setVisible(false)
    setCurrentStep(1)
    setApiOnboardSucess(false)
    setAccessData([])
    resetSelectionsDataOnSubmit()
    navigation.reset({
      index: 0,
      routes: [{ name: 'merchantonboarding' }],
    })
  }
  const handlePostSaveSubmit = useCallback(() => {
    setVisible(false)
    setCurrentStep(1)
    setApiOnboardSucess(false)
    setAccessData([])
    setMessage('Merchant is configured successfully', MessageTypes.SUCCESS, '999')
  }, [setMessage, setVisible])

  useEffect(() => {
    if (isAllPciSelected || isAllCommonPciNonPciSelected || isAllEmisSelected || isAllOthersSelected) {
      const isAllTrue =
        othersUpdateHandler.state === 'fulfilled' ||
        emiUpdateHandler.state === 'fulfilled' ||
        commonPciUpdateHandler.state === 'fulfilled' ||
        pciUpdateHandler.state === 'fulfilled'
      setAllApiFulfilled(isAllTrue)
      if (isAllTrue) {
        handlePostSaveSubmit()
        resetSelectionsDataOnSubmit()
        navigation.reset({
          index: 0,
          routes: [{ name: 'merchantonboarding' }],
        })
      }
    } else {
      const isAllTrue = updateIndividualApiStatusHandler.state === 'fulfilled'
      setAllApiFulfilled(isAllTrue)
      if (isAllTrue) {
        handlePostSaveSubmit()
      }
    }
  }, [
    commonPciUpdateHandler.state,
    emiUpdateHandler.state,
    handlePostSaveSubmit,
    isAllCommonPciNonPciSelected,
    isAllEmisSelected,
    isAllOthersSelected,
    isAllPciSelected,
    navigation,
    othersUpdateHandler.state,
    pciUpdateHandler.state,
    resetSelectionsDataOnSubmit,
    updateIndividualApiStatusHandler.state,
  ])

  useEffect(() => {
    if (insertCardsHandler.state === 'fulfilled') {
      if (isOnboarding) {
        setCurrentStep(4)
      } else {
        setCurrentStep(3)
      }
    }
  }, [insertCardsHandler.state, isOnboarding])

  useEffect(() => {
    if (insertConfigHandler.state === 'fulfilled') {
      if (isOnboarding) {
        setCurrentStep(3)
      } else {
        setCurrentStep(2)
      }
    }
  }, [insertConfigHandler.state, isOnboarding])

  useEffect(() => {
    isEmpty(accessConfig) && getUserDetailsApi()
  }, [accessConfig, getUserDetailsApi])

  if (!visible) {
    return null
  }

  const Header = (
    <Box {...styles.header}>
      <Text title={'Onboard New Merchant'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
      <Box onPress={handleCloseModal}>
        <Icon id={'CLOSE'} size={20} />
      </Box>
    </Box>
  )
  const Footer = () => {
    const titles: any = isOnboarding
      ? {
          1: apiOnboardSucess ? 'Proceed To General Configuration' : 'Onboard Merchant',
          2: 'Proceed To General Configuration',
          3: 'Proceed To Payment Configuration',
          4: 'Save & Submit',
        }
      : {
          1: 'Save Changes',
          2: 'Save Changes',
          3: 'Save & Submit',
        }

    const handleFooterPress = () => {
      if (isOnboarding) {
        if (currentStep === 1 && !apiOnboardSucess) {
          const merchantData = {
            mid: mid,
            status: 'ACTIVE',
          }
          onboardMerchant(merchantData)
        } else if (currentStep === 1 && apiOnboardSucess) {
          setCurrentStep(currentStep + 1)
        } else if (currentStep === 4) {
          if (isAllPciSelected || isAllCommonPciNonPciSelected || isAllEmisSelected || isAllOthersSelected) {
            if (isAllPciSelected) {
              pciUpdateApi(getAllPciList(), channelId)
            }
            if (isAllCommonPciNonPciSelected) {
              commonPciNonPciApi(commonPciNonPciList(), channelId)
            }
            if (isAllEmisSelected) {
              emiUpdateApi(getEmiList(), channelId)
            }
            if (isAllOthersSelected) {
              othersUpdateApi(getOthersApisList(), channelId)
            }
          } else {
            updateIndividualApiStatusApi()
          }
        } else if (currentStep === 3) {
          const paymentConfigData = getPaymentConfigData()
          insertConfigListApi(mid, paymentConfigData, false)
          const metaConfigList = getMetaConfigListRequestData()
          insertMetaConfigListApi(mid, metaConfigList, false)
          if (cardsList.length > 0) {
            insertCardsApi(mid, cardsList, false)
          }
        } else if (currentStep === 2) {
          const getDefaultConfigs = getDefaultConfigsToInsert()
          insertConfigApi(mid, getDefaultConfigs, false)
        }
      } else {
        setCurrentStep(currentStep + 1)
        if (currentStep === 1) {
          const getDefaultConfigs = getDefaultConfigsToInsert()
          insertConfigApi(mid, getDefaultConfigs, true)
        } else if (currentStep === 3) {
          //TODO: check for last api call state and then call below func
          if (isAllApiFulfilled) {
            handlePostSaveSubmit()
          }
        } else if (currentStep === 2) {
          if (cardsList.length > 0) {
            insertCardsApi(mid, cardsList, true)
          }
          const paymentConfigData = getPaymentConfigData()
          insertConfigListApi(mid, paymentConfigData, true)
          const metaConfigList = getMetaConfigListRequestData()
          insertMetaConfigListApi(mid, metaConfigList, true)
        }
      }
    }

    const isGeneralConfigValid =
      !!integrationType && !!offers && !!sodexo && !!subscriptions && !!emiFlag && !!tokenizationFlag && !!collectLink

    const isValid: any = {
      1: isOnboarding ? mercName?.length >= 3 : true,
      2: isOnboarding ? isGeneralConfigValid : true,
      3: true,
      4: true,
    }
    return (
      <Box {...styles.footer}>
        <ButtonNew
          onPress={handleFooterPress}
          title={titles[currentStep] ?? 'Save & Submit'}
          width={320}
          height={40}
          isLoading={false}
          disabled={!isValid[currentStep]}
        />
      </Box>
    )
  }
  const renderMerchantOnboarding = (): ReactElement => {
    const getScreen: any = isOnboarding
      ? {
          // 1: <MmsOnboarding mid={mid} />,
          1: <ApiOnboarding mid={mid} showSuccess={apiOnboardSucess} />,
          2: <GeneralConfig isOnboarding={isOnboarding} />,
          3: <PaymentConfig type={'MO'} mid={mid} />,
          4: <ApiConfig accessData={accessData} type={'MO'} isOnboarding={isOnboarding} channelId={channelId} />,
        }
      : {
          1: <GeneralConfig isOnboarding={isOnboarding} />,
          2: <PaymentConfig type={'MO'} mid={mid} />,
          3: <ApiConfig accessData={accessData} type={'MO'} isOnboarding={isOnboarding} channelId={channelId} />,
        }
    return (
      <Box {...styles.modal}>
        <Box {...styles.container}>
          {Header}
          <Box flexDirection={'row'} f={1}>
            <Box w={220}>
              <VerticalStepIndicator currentStep={currentStep} steps={getSteps(isOnboarding)} />
            </Box>
            <Box flexGrow={1} f={1}>
              {getScreen[currentStep]}
            </Box>
          </Box>
          {Footer()}
        </Box>
      </Box>
    )
  }
  return ReactDOM.createPortal(renderMerchantOnboarding(), document.body)
}

const styles = {
  modal: {
    position: 'absolute',
    elevation: 2,
    shadowOpacity: 1,
    opacity: 1,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 3,
    shadowColor: '#0000001F' as ColorOptions,
    zIndex: 1,
    align: 'center',
    justify: 'center',
    borderColor: 'GRAY_BORDER',
    backgroundColor: '#00000080' as ColorOptions,
  } as BoxProps,
  container: {
    backgroundColor: 'WHITE',
    borderRadius: 8,
    shadowRadius: 3,
    w: '70%',
    h: '95%',
    shadowColor: '#0000001F' as ColorOptions,
    zIndex: 1,
  } as BoxProps,
  header: {
    flexDirection: 'row',
    p: 24,
    justify: 'space-between',
    align: 'center',
    borderBottomWidth: 1,
    borderBottomColor: '#0000001F' as ColorOptions,
  } as BoxProps,
  footer: {
    p: 16,
    justify: 'center',
    align: 'flex-end',
    borderTopWidth: 1,
    borderTopColor: '#0000001F' as ColorOptions,
  } as BoxProps,
}
export default MerchantOnboarding
